import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { createPortal } from 'react-dom';
import { langCheck, startIntro } from "Pub/js/utils";
import End from "./end";
import "../../components/AccountActivation/intro.css";
import "./index.less";
import GuideIcon from "Assets/images/NoviceGuide/guide.svg";
import VideoIcon from "Assets/images/NoviceGuide/video.svg";
import GuideIconBlack from "Assets/images/NoviceGuide/guide-black.svg";
import VideoIconBlack from "Assets/images/NoviceGuide/video-black.svg";
import VideoGuide from "../VideoGuide";

class NoviceGuide extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showVideo: false,
            showModal: false,
        }
    }

    // 播放视频
    videoPlay = () => {
        this.setState({
            showVideo: true
        })
    }

    // 新手引导看完后弹框
    setShowModal = () => {
        const doc = window.document
        // 定义this.node 创建一个div节点
        this.node = doc.createElement("div")
        // 当前的body下挂载一个div节点
        doc.body.appendChild(this.node)
        this.setState({
            showModal: true
        })
    }
    render() {
        const { showVideo, showModal } = this.state;
        const { renderLinkageIcons, is_cloud_register, deployType, appOption, themeColor } = this.props;
        const { width, height } = appOption;
        const themeBlack = themeColor === 'black';
        return (
            <React.Fragment>
                <div fieldid='novice_guide' className={`novice-guide-box theme-${themeColor}`}>
                    <div className="notice-guide-header">
                        <span className='notice-guide-title'>
                            {langCheck('0000PUB-000440')  /** 多语 - 新手引导  */}
                        </span>
                        {renderLinkageIcons && renderLinkageIcons()}
                    </div>
                    <div className="notice-content">
                        {
                            !(Number(width) < 6 && Number(height) < 6) && <div className="notice-desc">
                                <span className="circle-point"></span>
                                {/* 为您推荐2主题，助您快速上手 */}
                                {langCheck('0000PUB-000637')}                        
                            </div>
                        }
                        <div className={`notice-items display-${Number(width) < 6 ? 'vertical' : 'horizontal'}`}>
                            <div className="notice-item" onClick={startIntro.bind(this, this.setShowModal, is_cloud_register, deployType)}>
                                <div className="item-title">
                                    <img className="item-icon" src={themeBlack ? GuideIconBlack : GuideIcon} />
                                    {/* 新手指引 */}
                                    <span className="label">{langCheck('0000PUB-000438')}</span>
                                </div>
                                {/* 快速查看工作台重要功能 */}
                                <p className="item-desc">{langCheck('0000PUB-000638')}</p>
                            </div>
                            <div className="split-line"></div>
                            <div className="notice-item" onClick={this.videoPlay}>
                                <div className="item-title">
                                    <img className="item-icon" src={themeBlack ? VideoIconBlack : VideoIcon} />
                                    {/* 产品介绍 */}
                                    <span className="label">{langCheck('0000PUB-000639')}</span>
                                </div>
                                {/* 了解产品亮点与高效功能 */}
                                <p className="item-desc">{langCheck('0000PUB-000640')}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <VideoGuide show={showVideo} onCancel={() => { this.setState({ showVideo: false }) }} />
                {
                    showModal && createPortal(<End
                        onClose={() => {
                            this.setState({
                                showModal: false
                            })
                        }}
                        onAgain={() => {
                            startIntro(this.setShowModal, is_cloud_register, deployType);
                            this.setState({
                                showModal: false
                            })
                        }}
                    />, this.node)
                }
            </React.Fragment>
        );
    }
}

export default withRouter(
    connect(
        state => ({
            is_cloud_register: state.appData.is_cloud_register,
            deployType: state.appData.deployType,
        }),
        {
        }
    )(NoviceGuide)
);